exports.components = {
  "component---src-templates-pages-form-tsx": () => import("./../../../src/templates/pages/form.tsx" /* webpackChunkName: "component---src-templates-pages-form-tsx" */),
  "component---src-templates-pages-index-tsx": () => import("./../../../src/templates/pages/index.tsx" /* webpackChunkName: "component---src-templates-pages-index-tsx" */)
}

